import { Component, OnInit, Input, SimpleChanges, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { ITypesSelection } from 'src/app/core/interfaces/types-selection.interface';
import { TexteService } from 'src/app/core/services/texte.service';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { IMedecin } from 'src/app/core/interfaces/medecin.interface';
import { ToolboxService } from 'src/app/core/services/toolbox.service';

@Component({
    selector: 'app-medecin-form',
    templateUrl: './medecin-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MedecinFormComponent implements OnInit, OnChanges {

  @Input() typesSelected: ITypesSelection;
  @Input() indicatifs: number[];
  public medecinForm: FormGroup;

  constructor(
    public texteService: TexteService,
    private toolboxService: ToolboxService
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.typesSelected != null && !changes.typesSelected.firstChange) {
      this.buildForm();
    }
    if (changes.indicatif != null && !changes.indicatif.firstChange && this.indicatifs.length > 0) {
      this.medecinForm.get('indicatif').setValue(this.indicatifs[0]);
    }
  }

  private buildForm() {
    this.medecinForm = new FormGroup({
      nom: new FormControl('', this.typesSelected.situation.code === 'MED' ? Validators.required : null),
      prenom: new FormControl('', this.typesSelected.situation.code === 'MED' ? Validators.required : null),
      telephone: new FormControl('',
        this.typesSelected.situation.code === 'MED' ?
          [Validators.required, this.toolboxService.telValidator()] :
          this.toolboxService.telValidator()),
      email: new FormControl('',
        this.typesSelected.situation.code === 'MED' ?
          [Validators.required, Validators.email] :
          Validators.email)
    });

    if (this.typesSelected.situation.code === 'MED') {
      this.medecinForm.addControl('numero', new FormControl('', [Validators.required, this.rppsValidator()]));
    }

    if (this.typesSelected.situation.code === 'INT') {
      this.medecinForm.addControl('etablissement', new FormControl(''));
      this.medecinForm.addControl('specialite', new FormControl(''));
      this.medecinForm.addControl('indicatif', new FormControl(this.indicatifs.length > 0 ? this.indicatifs[0] : '',
        [this.toolboxService.indicatifValidator(), Validators.required]));
    }
  }

  rppsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (this.toolboxService.stringIsNullOrWhiteSpace(control.value.toString())) {
        return null;
      }
      const regexp = new RegExp(/^\d{11}$/g);
      const match = regexp.test(control.value);

      return match ? null : { rppsUnvalid: true };
    };
  }

  public isValid(): boolean {
    return this.medecinForm.valid;
  }

  public getForm(): IMedecin {
    let tel: string;
    if (this.typesSelected.situation.code === 'INT' &&
      !this.toolboxService.stringIsNullOrWhiteSpace(this.medecinForm.get('telephone').value)) {
      tel = '+' + this.medecinForm.get('indicatif').value + ' ' + this.medecinForm.get('telephone').value;
    } else {
      tel = this.medecinForm.get('telephone').value;
    }

    return {
      numeroRpps: this.typesSelected.situation.code === 'MED' ? this.medecinForm.get('numero').value : null,
      nom: this.medecinForm.get('nom').value,
      prenom: this.medecinForm.get('prenom').value,
      etablissement: this.typesSelected.situation.code === 'INT' ? this.medecinForm.get('etablissement').value : null,
      specialite: this.typesSelected.situation.code === 'INT' ? this.medecinForm.get('specialite').value : null,
      telephone: tel,
      email: this.medecinForm.get('email').value,
    } as IMedecin;
  }
}
